'use client';

import { useEffect } from 'react';
import { initialiseOfflineAccount } from '@/lib/offline/context';

export function OfflineAccountLifecycle() {
  useEffect(() => { void initialiseOfflineAccount().catch(() => undefined); }, []);
  return null;
}
